import { withProps } from 'recompose';

import Link from '../Link';

export const enhance = withProps(({ components, theme }) => ({
  components: { a: withProps({ theme })(Link), ...components },
}));
